<template>
    <div v-if="showAlarm" class="modal-alarm-msg" :class="{error: type == 'ERROR'}">
        <img v-if="type == 'SUCCESS'" src="@/assets/img/icon/tick_blue.svg" alt="">
        <img v-if="type == 'ERROR'" src="@/assets/img/icon/info_white.svg" alt="">
        <span>{{msg}}</span>
    </div>
</template>
<script>

export default {
    data () {
        return {
        }
    },
    props: {
        showAlarm: Boolean,
        msg: String,
        count: Number,
        type: String,
    },
    watch: {
        showAlarm: {
            handler: function (val) {
                if(val){
                    this.showTip()
                }
            },
            immediate: true
        }
    },
    methods: {
        showTip: function () {
            var _self = this;
            setTimeout(function() {
                _self.$emit('timeOut')
            }, _self.count); 
        },
    }

}
</script>
<style lang="scss"  >
    .modal-alarm-msg{
        position: fixed;
        top: 40px;
        border-radius: 4px;
        background-color: #ffffff;
        padding: 8px 16px;
        display: flex;
        align-items: center;
        left: 50%;
        transform: translateX(-50%);
        color: #292625;
        img{
            margin-right: 2px;
        }
        &.error{
            background-color: #fc7171;
            color: #ffffff;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/alarms/alarmMsgWhite.vue